"use strict";

const http = require("client/http_client");
const staticData = require("client/static_data");

module.exports = function dataAccess () {


    function _downloadFile (href) {
        const axiosConfig = {
            url: href,
            method: "head"
        };
        http(axiosConfig).then(function () {
            window.location.href = href;
        }).catch(function (error) {
            /**
             * A HEAD that fails without a response (network down, timeout,
             * aborted) has no x-message header: the native navigation was
             * already cancelled, so the banner must still be shown.
             */
            const payload = {
                error: error.response ?
                    error.response.headers["x-message"] :
                    staticData.errors.FILE_NOT_FOUND.message
            };
            document.dispatchEvent(new CustomEvent('DOWNLOAD_FILE_ERROR', { detail: payload }));
        })
    }

    document.addEventListener('DOWNLOAD_FILE', (e) => {
        _downloadFile(e.detail.href);
    });

    return {


        sendTextEmail: function (payload) {
            const url = "/api/email"
            return http.post(url, payload);
        },
        getCaptcha: function () {
            const url = "/api/captcha";

            return http.get(url);
        },
        search: function (payload) {

            const url = "/api/bic/search";
            const challenge = payload.challenge;
            delete payload.challenge;

            return http.post(url, payload, {
                headers: {
                    "x-challenge": challenge
                }
            });

        }
    };
};
